import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ListObligations from "./List";
import { DEBTS, DebtServicePath } from "utils/constants";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <RequestQuoteIcon />,
  name: DebtServicePath + DEBTS,
  title: "Задължения",
  list: <ListObligations />,
  permission: permissions.canPreviewDebts,
};
